<template>
	<nav v-if="item" class="navbar navbar-default navbar-custom">
		<div class="container-fluid bold-400">
			<div class="navbar-header navbar-header-custom">
				<button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
					<span class="sr-only">Toggle navigation</span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
				</button>
				<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/projects/projects/' + item.id" class="navbar-brand navbar-brand-custom bold">
					Proyecto {{ $platform.setting.number_symbol }}{{ item.id }}
				</router-link>
			</div>

			<div class="collapse navbar-collapse navbar-collapse-custom" id="bs-example-navbar-collapse-1">
				<ul class="nav navbar-nav">
					<li :class="'list-group-item-' + item.status.class">
						<a @click="$refs.ChangeStatus.open(item)" href="javascript:void(0)">
							<span v-html="item.status.icon"></span>
							{{ item.status.name }}
						</a>
					</li>
					<li>
						<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/projects/projects/' + item.id + '/customers'">
							<i class="fa fa-address-card-o fa-fw" aria-hidden="true"></i>
							Clientes
							<template v-if="item.info">
								<span v-if="item.info.customers" class="label label-rouded label-info">{{ item.info.customers }}</span>
							</template>
						</router-link>
					</li>
					<li>
						<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/projects/projects/' + item.id + '/tasks'">
							<i class="fa ti ti-flag-alt fa-fw" aria-hidden="true"></i>
							Tareas
							<template v-if="item.info">
								<span v-if="item.info.tasks" class="label label-rouded label-info">{{ item.info.tasks }}</span>
							</template>
						</router-link>
					</li>
					<li>
						<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/projects/projects/' + item.id + '/budgets'">
							<i class="fa fa-clipboard fa-fw" aria-hidden="true"></i>
							Presupuestos
							<template v-if="item.info">
								<span v-if="item.info.budgets" class="label label-rouded label-info">{{ item.info.budgets }}</span>
							</template>
						</router-link>
					</li>
					<!--
					<li>
						<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/projects/projects/' + item.id + '/calendar'">
							<i class="ti ti-calendar fa-fw" aria-hidden="true"></i>
							Calendario
						</router-link>
					</li>-->
				</ul>
				<form class="navbar-form navbar-left">
					<template v-if="item.user">
						<template v-if="item.user.profile">
							<template v-if="item.user.profile.avatar">
								<div class="form-group">
									<a @click="$refs.Coordinator.open(item)" href="javascript:void(0)">
										<img :src="item.user.profile.avatar" class="img-circle" width="30px"
											:alt="item.user.email"
											:title="item.user.email">
										<span class="visible-xs-inline">
											{{ item.user.email }}
										</span>
									</a>
								</div>
							</template>
						</template>
					</template>
				</form>
				<ul class="nav navbar-nav navbar-right">
					<li @click="$refs.projectsMap.open()">
						<a href="javascript:void(0)" title="Mapa">
							<span class="hidden-xs">
								<i class="fa fa-map" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								<i class="fa fa-map fa-fw" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								Mapa
							</span>
						</a>
					</li>
					<li>
						<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/projects/projects/' + item.id + '/comments'" title="Comentarios">
							<span class="hidden-xs">
								<i class="fa fa-comments-o" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								<i class="fa fa-comments-o fa-fw" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								Comentarios
							</span>
							<template v-if="item.info">
								<span v-if="item.info.comments" class="label label-rouded label-info">{{ item.info.comments }}</span>
							</template>
						</router-link>
					</li>
					<li>
						<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/projects/projects/' + item.id + '/incidents'" title="Incidentes">
							<span class="hidden-xs">
								<i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								<i class="fa fa-exclamation-triangle fa-fw" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								Incidentes
							</span>
							<template v-if="item.info">
								<span v-if="item.info.incidents" class="label label-rouded label-info">{{ item.info.incidents }}</span>
							</template>
						</router-link>
					</li>
					<li>
						<router-link :to="'/' + $i18n.locale + '/' + $platform.slug + '/admin/projects/projects/' + item.id + '/docs'" :title="$tc('interface.doc', 2) | ucfirst">
							<span class="hidden-xs">
								<i class="fa fa-folder-open-o" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								<i class="fa fa-folder-open-o fa-fw" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								{{ $tc('interface.doc', 2) | ucfirst }}
							</span>
							<template v-if="item.info">
								<span v-if="item.info.media" class="label label-rouded label-info">{{ item.info.media }}</span>
							</template>
						</router-link>
					</li>
					<li v-if="type == 'show'" @click="doPrint()">
						<a href="javascript:void(0)" :title="$t('interface.print') | ucfirst">
							<span class="hidden-xs">
								<i class="fa fa-print" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								<i class="fa fa-print fa-fw" aria-hidden="true"></i>
							</span>
							<span class="visible-xs-inline">
								{{ $t('interface.print') | ucfirst }}
							</span>
						</a>
					</li>
				</ul>
			</div>
		</div>

		<fab
			:type="type"
			:item="item"
			:user="user"
			:isAuth="isAuth"
			@reload="reload">
		</fab>

		<change-status
			@reload="reload"
			ref="ChangeStatus"
			:user="user"
			:isAuth="isAuth">
		</change-status>

		<coordinator
			@reload="reload"
			ref="Coordinator"
			:user="user"
			:isAuth="isAuth">
		</coordinator>

		<projects-map
			ref="projectsMap"
			:isAuth="isAuth"
			:project="item"
			:user="user">
		</projects-map>
	</nav>
</template>

<script>
	import swal from 'sweetalert2'
	import Fab from './Fab'
	import ChangeStatus from './ChangeStatus'
	import Coordinator from './Coordinator'
	import ProjectsMap from './ProjectsMap'

	export default {
		props: ['user', 'isAuth', 'item', 'type'],
		components: {
			'fab': Fab,
			'change-status': ChangeStatus,
			'coordinator': Coordinator,
			'projects-map': ProjectsMap,
		},
		created() {
			this.init()
		},
		data () {
			return {
				statuses: null,
			}
		},
		methods: {
			init() {
				this.getStatuses()
			},
			getStatuses() {
				this.$http.get('admin/projects/projects/statuses')
				.then(response => {
					this.statuses = response.body
				})
			},
			reload() {
				this.$emit('reload')
			},
			doPrint() {
				$(".printableArea").printThis({
					canvas: true,
				})
			},
		}
	};
</script>


// WEBPACK FOOTER //
// src/components/projects/projects/views/Navbar.vue